export default [
    {
        path: '/admin/collateral-records',
        name: 'collateral-record',
        meta: { requiresAuth: true },
        component: () => import('@/pages/credit-operation/collateral-record')
    }
]
